export default {
      id: "generator-ok-usage",
      viewBox: "0 0 85 62",
      url: __webpack_public_path__ + "img/icons.svg#generator-ok",
      toString: function () {
        return this.url;
      }
    }